<template>
  <v-container fluid class="pa-4">
    <v-row justify="space-between" align="center" class="mb-6">
      <v-col cols="12" sm="7">
        <h1 class="text-h4 font-weight-bold primary--text">
          <v-icon large color="primary" class="mr-3">mdi-calculator</v-icon>
          {{ $t('golf_handicaps') || 'Handicaps de Golf' }}
        </h1>
        <div class="grey--text text--darken-1">
          {{ $t('golf_handicaps_description') || 'Resumen de handicap vigente y desempeño reciente por jugador.' }}
        </div>
      </v-col>
      <v-col cols="12" sm="5" class="text-sm-right">
        <v-btn color="primary" rounded outlined @click="loadHandicaps" :loading="loading">
          <v-icon left small>mdi-refresh</v-icon>
          {{ $t('actualizar') || 'Actualizar' }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="search"
          prepend-icon="mdi-magnify"
          :label="$t('buscar_jugador') || 'Buscar jugador'"
          outlined
          dense
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="8">
        <div class="grey--text text--darken-1">
          <strong>Promedio del club:</strong> {{ clubAverage }} |
          <strong>Mejor jugador:</strong> {{ bestHandicap }} |
          <strong>Total de jugadores:</strong> {{ filteredPlayers.length }}
        </div>
      </v-col>
    </v-row>

    <v-card class="elevation-2">
      <v-card-title>
        {{ $t('handicap_list') || 'Listado de Handicaps' }}
        <v-spacer></v-spacer>
        <v-chip color="primary" small text-color="white">{{ filteredPlayers.length }}</v-chip>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="filteredPlayers"
          :loading="loading"
          :no-data-text="$t('no_records_yet') || 'Sin resultados'"
          class="elevation-0"
          @click:row="selectPlayer"
        >
          <template v-slot:item.official_handicap="{ item }">
            <v-chip color="primary" dark small>{{ item.official_handicap }}</v-chip>
          </template>
          <template v-slot:item.updated_at="{ item }">
            {{ formatDate(item.updated_at) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Detail Modal -->
    <HandicapDetailDialog
      :visible="showDetail"
      :handicap="selectedHandicap"
      :isAdmin="isAdmin"
      @close="showDetail = false"
      @refresh="loadHandicaps"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import HandicapDetailDialog from './components/HandicapDetailDialog.vue'

export default {
  name: 'GolfHandicaps',
  components: {
    HandicapDetailDialog
  },
  data () {
    return {
      search: '',
      showDetail: false,
      selectedHandicap: null,
      headers: [
        { text: 'Jugador', value: 'user_display', sortable: true },
        { text: 'Handicap Oficial', value: 'official_handicap', sortable: true },
        { text: 'Rondas', value: 'rounds_count', sortable: true },
        { text: 'Última actualización', value: 'updated_at', sortable: true }
      ]
    }
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState('handicap', {
      loading: 'loading',
      error: 'error',
      allHandicaps: 'allHandicaps'
    }),
    isAdmin () {
      const user = this.getProfile
      return user?.is_staff === true || user?.is_superuser === true
    },
    clubAverage () {
      return this.$store.getters['handicap/clubAverageHandicap']
    },
    bestHandicap () {
      const best = this.$store.getters['handicap/bestHandicapInClub']
      return best?.official_handicap || '--'
    },
    filteredPlayers () {
      const search = (this.search || '').toLowerCase().trim()
      if (!search) {
        return this.allHandicaps
      }

      return this.allHandicaps.filter(player => {
        return (player.user_display || '').toLowerCase().includes(search)
      })
    }
  },
  mounted () {
    this.loadHandicaps()
  },
  methods: {
    ...mapActions('handicap', ['fetchAllHandicaps']),
    async loadHandicaps () {
      await this.fetchAllHandicaps()
    },
    selectPlayer (item) {
      this.selectedHandicap = item
      this.showDetail = true
    },
    formatDate (date) {
      if (!date) return '--'
      return new Date(date).toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })
    }
  }
}
</script>
